import { useId, useMemo, useState } from 'react'
import { CheckIcon, EfsaSampnt, Mtds } from 'prove-common'

type EditableSampntTypeFieldProps = {
  value?: number
  sampntTypes: EfsaSampnt[]
  canEdit: boolean
  isSaving?: boolean
  onSave: (sampntTypeId: number) => void | Promise<void>
}

export const EditableSampntTypeField = ({
  value,
  sampntTypes,
  canEdit,
  isSaving = false,
  onSave
}: EditableSampntTypeFieldProps) => {
  const popoverId = useId()
  const [search, setSearch] = useState('')

  const selected = sampntTypes.find((sampntType) => sampntType.id === value)

  const filtered = useMemo(() => {
    const query = search.trim().toLowerCase()
    if (!query) return sampntTypes
    return sampntTypes.filter((sampntType) =>
      sampntType.nameNo.toLowerCase().includes(query)
    )
  }, [search, sampntTypes])

  if (!canEdit) return <>{selected?.nameNo ?? '-'}</>

  const handleSelect = (nextId: number) => {
    if (nextId !== value) void onSave(nextId)
    setSearch('')
  }

  return (
    <>
      <Mtds.Button
        type='button'
        data-variant='tertiary'
        popoverTarget={popoverId}
        disabled={isSaving}
        className='-mx-1 h-auto min-h-0 justify-start p-1 font-normal'
      >
        {selected ? (
          selected.nameNo
        ) : (
          <span style={{ color: 'var(--mtds-color-text-subtle)' }}>
            Velg uttakssted
          </span>
        )}
      </Mtds.Button>
      <Mtds.Popover id={popoverId} className='w-72 p-2'>
        <div className='grid gap-2'>
          <Mtds.Heading as='p' data-size='2xs'>
            Velg uttakssted
          </Mtds.Heading>
          <Mtds.Field
            as='input'
            type='search'
            aria-label='Søk etter uttakssted'
            placeholder='Søk...'
            value={search}
            onChange={({ target }) => setSearch(target.value)}
          />
          <menu className='grid max-h-72 gap-1 overflow-x-hidden overflow-y-auto p-0'>
            {filtered.map((sampntType) => (
              <li key={sampntType.id}>
                <Mtds.Button
                  type='button'
                  data-variant='tertiary'
                  popoverTargetAction='hide'
                  popoverTarget={popoverId}
                  onClick={() => handleSelect(sampntType.id)}
                  className='w-full min-w-0 justify-between break-words font-normal'
                >
                  {sampntType.nameNo}
                  {sampntType.id === value && <CheckIcon aria-hidden />}
                </Mtds.Button>
              </li>
            ))}
            {filtered.length === 0 && (
              <li>
                <Mtds.Muted className='px-2 py-1'>Ingen treff</Mtds.Muted>
              </li>
            )}
          </menu>
        </div>
      </Mtds.Popover>
    </>
  )
}
